import React from 'react';
import { ChakraV3 } from '..';

export interface QRCodeProps extends ChakraV3.QrCodeRootProps {}

export const QRCode = (props: QRCodeProps) => {
  return (
    <ChakraV3.QrCode.Root size='full' {...props}>
      <ChakraV3.QrCode.Frame>
        <ChakraV3.QrCode.Pattern />
      </ChakraV3.QrCode.Frame>
    </ChakraV3.QrCode.Root>
  );
};
